import {GlobalLogin} from '/src/com/yext/platform/users/globallogin/js/globallogin';
import {NewGlobalLogin} from '/src/com/yext/platform/users/globallogin/js/newgloballogin';

var initElements = document.getElementsByClassName('js-yext-login-init');

if (initElements.length > 0) {
  const initData = JSON.parse(initElements[0].innerHTML);
  window['cspStyleNonce'] = initData['cspStyleNonce'];
}
